import MasterLayout from "../../../masterLayout/MasterLayout";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { createMRTColumnHelper } from "material-react-table";
import { baseUrl } from "../../../helper/urls";
import CustomTable from "../../../components/custom_table/CustomTable";
import { toast, ToastContainer } from "react-toastify";
import { IconButton, Stack, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useSelector } from "react-redux";

const AdminScheduledBookingList = () => {
  const { token } = useSelector((state) => state.auth);
  const [bookings, setBookings] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const url = `${baseUrl}/bookings/getBookingScheduleByAdmin`;

  const fetchBookings = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.get(url, { headers });
      //   console.log("response:::::::::::::::::::::", response.data.data);

      setBookings(response.data.data || []);
      setLoading(false);
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  function formatUtcTimeTo12Hour(timeStr) {
  if (!timeStr) return "N/A";
  const d = new Date(timeStr);
  let h = d.getUTCHours(), m = d.getUTCMinutes(), s = d.getUTCSeconds();
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")} ${ampm}`;
}


  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("meet_link", {
      header: "Google Meet Link",
      size: 30,
      Cell: (cell) => {
        const link = cell.row.original?.meet_link;

        if (!link) return "-";

        const handleCopy = async () => {
          try {
            await navigator.clipboard.writeText(link);
            toast.success("Link copied to clipboard!");
            // alert("Link copied to clipboard!");
          } catch (err) {
            console.error("Failed to copy:", err);
          }
        };

        return (
          <Stack direction="row" spacing={1}>
            <Tooltip title="Copy Link">
              <IconButton size="small" onClick={handleCopy}>
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Open Link">
              <IconButton
                size="small"
                onClick={() => window.open(link, "_blank")}
              >
                <OpenInNewIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    }),
    columnHelper.accessor("student_id", {
      header: "Student Name",
      size: 30,
      Cell: (cell) =>
        cell.row.original?.firstName + " " + cell.row.original?.lastName,
    }),
    columnHelper.accessor("counselor_id", {
      header: "Counselor Name",
      size: 30,
      Cell: (cell) =>
        cell.row.original?.c_firstname + " " + cell.row.original?.c_lastname,
    }),
    columnHelper.accessor("booking_date", {
      header: "Slot Date (UTC)",
      size: 30,
      // Cell: (cell) => cell.row.original.booking_date?.split("T")[0] || "N/A",
      Cell: (cell) => cell.row.original.utcTime?.split("T")[0] || "N/A",
    }),
    columnHelper.accessor("booking_time", {
      header: "Slot Time  (UTC)",
      size: 30,
      Cell: (cell) => formatUtcTimeTo12Hour(cell.row.original.utcTime),
    }),
    columnHelper.accessor("reqId", {
      header: "Request ID",
      size: 20,
      Cell: (cell) => "DDR000" + cell.row.original?.reqId,
    }),
  ];

  return (
    <MasterLayout>
      <ToastContainer position="top-right" autoClose={2000} />
      <CustomTable columns={columns} data={bookings} loading={loading} />
    </MasterLayout>
  );
};

export default AdminScheduledBookingList;
